import { Gift, Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import Logo, { WhatsAppIcon } from "../Logo";
import { waLink } from "../../api";

export function FloatingReferral() {
  return (
    <a
      href="#referidos"
      data-testid="floating-referral-btn"
      aria-label="Plan amigo: consigue pedidos gratis"
      className="fixed bottom-6 left-6 z-50 flex items-center gap-2 rounded-full bg-gradient-to-r from-[#2EE6D6] to-[#7C5CFF] py-3 pl-3.5 pr-5 text-black shadow-[0_8px_24px_rgba(124,92,255,0.45)] transition-transform hover:scale-105 animate-fade-up"
    >
      <Gift className="h-5 w-5" />
      <span className="text-xs font-extrabold leading-tight sm:text-sm">
        Plan amigo
        <span className="block text-[10px] font-semibold sm:text-xs">Pedidos GRATIS</span>
      </span>
    </a>
  );
}

export function FloatingWhatsApp() {
  return (
    <a
      href={waLink("Hola NubeVape España, tengo una consulta.")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Abrir chat de WhatsApp"
      className="animate-pulse-ring fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-black shadow-[0_8px_24px_rgba(37,211,102,0.4)] transition-transform hover:scale-110"
    >
      <WhatsAppIcon className="h-7 w-7" />
    </a>
  );
}

export default function SiteFooter() {
  return (
    <footer data-testid="legal-footer" className="border-t border-[#2D323E] bg-[#16181D] px-4 py-12 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
          <Logo />
          <a
            href={waLink("Hola NubeVape España, tengo una consulta.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-btn"
            className="flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-2.5 text-sm font-bold text-black transition-colors hover:bg-[#20BA5A]"
          >
            <WhatsAppIcon className="h-4 w-4" />
            WhatsApp: 610 93 55 31
          </a>
          <a
            href="tel:+34610935531"
            data-testid="footer-phone-link"
            className="flex items-center gap-2 text-sm text-[#8A8F98] transition-colors hover:text-[#2EE6D6]"
          >
            <Phone className="h-4 w-4" /> +34 610 93 55 31
          </a>
          <a
            href="mailto:info@nubevaper.com"
            data-testid="footer-email-link"
            className="flex items-center gap-2 text-sm text-[#8A8F98] transition-colors hover:text-[#2EE6D6]"
          >
            <Mail className="h-4 w-4" /> info@nubevaper.com
          </a>
        </div>

        <div className="mt-10 rounded-2xl border border-[#F59E0B]/30 bg-[#F59E0B]/5 p-5">
          <p className="text-xs leading-relaxed text-[#8A8F98]">
            <span className="font-bold text-[#F59E0B]">AVISO LEGAL +18:</span> Los productos de
            vapeo pueden contener nicotina, una sustancia adictiva. Venta prohibida a menores de
            18 años conforme a la Ley 28/2005 y al Real Decreto 579/2017. Este producto no es un
            método para dejar de fumar. Mantener fuera del alcance de los niños. No recomendado
            para mujeres embarazadas o en período de lactancia.
          </p>
        </div>

        <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2 border-t border-[#2D323E] pt-6 text-xs text-[#8A8F98]">
          <Link to="/aviso-legal" data-testid="footer-legal-notice-link" className="transition-colors hover:text-[#2EE6D6]">
            Aviso legal
          </Link>
          <Link to="/privacidad" data-testid="footer-privacy-link" className="transition-colors hover:text-[#2EE6D6]">
            Política de privacidad
          </Link>
          <Link to="/cookies" data-testid="footer-cookies-link" className="transition-colors hover:text-[#2EE6D6]">
            Política de cookies
          </Link>
        </div>

        <div className="mt-6 flex flex-col items-start justify-between gap-4 border-t border-[#2D323E] pt-6 text-xs text-[#8A8F98] md:flex-row md:items-center">
          <p>
            NubeVape España es una tienda independiente y no está afiliada ni respaldada por las
            marcas mencionadas. Todas las marcas comerciales pertenecen a sus respectivos
            propietarios.
          </p>
          <p>© {new Date().getFullYear()} NubeVape España. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
}
